import dayjs from 'dayjs';

import { TimeRange } from '@cast/shared-types';

import { createBooleanOverride, overrideOrValue } from 'core/dev-toolbox';
import { useReportCapabilitiesQuery } from 'hooks/queries/cost';

import { useCluster } from '@cast/shared-cluster-context-data-access';

const useClusterGpuAvailabilityOverride = createBooleanOverride(
  'clusterGpuAvailable'
);

type Result = {
  isLoading: boolean;
  isGpuAvailable: boolean;
  error: unknown;
  refetch(): void;
};

type Params = {
  range?: TimeRange;
};

export function useClusterGpuAvailability({ range }: Params = {}): Result {
  const { cluster } = useCluster();

  const startOfCurrentHour = dayjs().startOf('hour');

  const { data, isLoading, error, refetch } = useReportCapabilitiesQuery({
    clusterId: cluster.id,
    startTime: range
      ? range.from
      : startOfCurrentHour.subtract(1, 'hour').toISOString(),
    endTime: range ? range.to : startOfCurrentHour.endOf('hour').toISOString(),
    enabled: !!cluster.id,
  });

  const devOverride = useClusterGpuAvailabilityOverride();
  const isGpuAvailable =
    (data?.gpuDataAvailable ?? false) && (data?.gpuMetricsAvailable ?? false);

  return {
    isGpuAvailable: overrideOrValue(devOverride, isGpuAvailable),
    isLoading,
    error,
    refetch,
  };
}
